import {Controller, useFormContext} from 'react-hook-form';
import {AgreementClause} from '@guestapp/sdk';
import {getAgreementClausesData} from './getAgreementClausesData';
import {FieldsGroup} from 'components/FieldsGroup';
import {Label} from './Label';
import {Container, Checkbox, CheckboxWrapper} from './styled';

export const AgreementClausesKeyFormName = 'agreement_clauses';

type FormTypes = Record<string, boolean>;

type Props = {
  clauses?: AgreementClause[];
};
const AgreementClausesBox = ({clauses}: Props) => {
  const agreementClausesItems =
    clauses?.filter(clause => clause.is_active).map(getAgreementClausesData) || [];

  const {control} = useFormContext<FormTypes>();

  if (!agreementClausesItems.length) {
    return null;
  }

  return (
    <FieldsGroup title="Clauses" centered={false}>
      <Container>
        {agreementClausesItems.map(({name, body, required}) => (
          <CheckboxWrapper key={name}>
            <Controller
              name={`${AgreementClausesKeyFormName}.${name}`}
              control={control}
              rules={{required}}
              render={({field, fieldState: {error}}) => (
                <Checkbox
                  label={<Label body={body} required={required} />}
                  className="agreement-checkbox"
                  error={error?.message}
                  {...field}
                />
              )}
            />
          </CheckboxWrapper>
        ))}
      </Container>
    </FieldsGroup>
  );
};

export {AgreementClausesBox};
